import { render } from "./ContractProposalsPage.vue?vue&type=template&id=0f7f1550&scoped=true"
import script from "./ContractProposalsPage.vue?vue&type=script&lang=js"
export * from "./ContractProposalsPage.vue?vue&type=script&lang=js"

import "./ContractProposalsPage.vue?vue&type=style&index=0&id=0f7f1550&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7f1550"]])

export default __exports__